export const config = {
  title: "HIND DRIVING NEWYORK INC",
  meta: {
    description:
      "HIND DRIVING NEWYORK INC offers certified driving lessons in Brooklyn, NY — including theory preparation and in-car training with same-day service.",
    keywords: [
      "Driving School Brooklyn",
      "HIND DRIVING NEWYORK INC",
      "Brooklyn NY driving lessons",
      "Certified Driving Instructor",
      "NYC Driving Test Prep"
    ],
    author: "HIND DRIVING NEWYORK INC",
    canonicalUrl: "https://www.hinddrivingnewyork.com/",
  },
  sections: {
    header: {
      businessName: "HIND DRIVING NEWYORK INC",
    },
    sectionB: {
      heroTitle: "HIND DRIVING NEWYORK INC",
      heroSubtitle: "Certified Driving School in Brooklyn, NY",
      learnAboutText: "Explore Driving Programs",
      phoneNumber: "3476379379",
      phoneLabel: "(347) 637-9379",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1171634924/photo/woman-practice-driving-car-exam-driver-licence-control-steering-wheel-education-and-learn-on.jpg?s=612x612&w=0&k=20&c=jQdQiU7JoIW49HEr9yVzSBEOgZy5LtEAbouJ5OMWaTg=",
      cardData: [
        {
          title: "Certified Instruction",
          description:
            "Get behind the wheel with a licensed and experienced instructor.",
        },
        {
          title: "Theory Preparation",
          description:
            "Comprehensive test preparation for written permit exams.",
        },
        {
          title: "Same-Day Availability",
          description:
            "Flexible, same-day scheduling for urgent training needs.",
        },
      ],
      description:
        "At HIND DRIVING NEWYORK INC, we specialize in providing driving instruction and exam prep for residents in Brooklyn and surrounding boroughs. Whether you're new behind the wheel or brushing up your skills, we’re here to help.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive training from permit preparation to road test success.",
      cards: [
        {
          title: "Permit Test Prep",
          description: "Pass your written exam confidently with expert help.",
          imageSrc: "https://media.istockphoto.com/id/1125351656/photo/instructor-guiding-student-to-drive-car.jpg?s=612x612&w=0&k=20&c=MVLc-xxkT07_NF9vOKxrMHtSS1kpIs6xc4Lh-D-Z0Kk=",
          imageAlt: "Permit Test Preparation",
        },
        {
          title: "In-Car Driving Lessons",
          description:
            "Real-world driving experience with certified instructors.",
          imageSrc: "https://media.istockphoto.com/id/1335863186/photo/obstacle-course.jpg?s=612x612&w=0&k=20&c=c0gc7S0wYagSvlQcUofm8m73vGK50y2kRbi-CzfzNpI=",
          imageAlt: "In-Car Training",
        },
        {
          title: "Pre-Road Test Practice",
          description:
            "Mock tests and practice to ensure you're test-day ready.",
          imageSrc: "https://media.istockphoto.com/id/944111316/photo/examiner-filling-in-drivers-license-road-test-form.jpg?s=612x612&w=0&k=20&c=TvxTzw3YThtIr_bkWysb0h_Hu3jPMNf3CZTSap1pjXs=",
          imageAlt: "Road Test Practice",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Same-Day Appointments",
        "Flexible Scheduling",
        "Multilingual Instruction",
        "Local DMV Coordination",
        "Free Pickup & Drop-off (select zones)",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://assets.voolt.com/assets/2023/03/13220625/aboutus_driving_instructor.jpg",
        alt: "HIND Driving Team in Brooklyn",
      },
      aboutText: [
        "Founded with a mission to make driving instruction affordable and accessible, HIND DRIVING NEWYORK INC serves the Brooklyn community with pride.",
        "Our team of certified, multilingual instructors delivers driving education tailored to your pace, goals, and schedule — always with a focus on safety and confidence behind the wheel.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "HIND DRIVING Logo",
      businessName: "HIND DRIVING NEWYORK INC",
      contact: {
        phone: "3476379379",
        phoneLabel: "(347) 637-9379",
        email: "sunilkumarz123@gmail.com",
        website: "https://www.hinddrivingnewyork.com/",
        address: "330 McGuinness Boulevard, Brooklyn, NY 11222",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "330 McGuinness Boulevard, Brooklyn, NY 11222",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.567123456789!2d-73.95731248459436!3d40.72701287941767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a49c2c4f1b3%3A0xabcd1234abcd5678!2s330+McGuinness+Blvd%2C+Brooklyn%2C+NY+11222!5e0!3m2!1sen!2sus!4v1718654321876!5m2!1sen!2sus",
    },
  },
};

export default config;
